import React from "react";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { c } from "../classroomColors";

const StudentClassroomsTile = ({ content }) => {
  return (
    <Box
      display="flex"
      width="100%"
      flexDirection="column"
      alignItems="flex-start"
      gap="16px"
      // Same white card the assigned work tile sits in, so the cream cards
      // inside it read as cards rather than melting into the cream page.
      background={c.surface}
      borderRadius="12px"
      padding="24px"
      boxShadow="sm"
    >
      <Flex alignItems="center" gap="8px">
        <Icon as={HiOutlineUserGroup} boxSize={5} color={c.text} />
        <Text
          color={c.text}
          fontSize="20px"
          fontWeight="500"
        >
          My Spaces
        </Text>
      </Flex>

      <Box
        display="flex"
        minHeight="113px"
        width="100%"
        alignItems="flex-start"
        alignSelf="stretch"
      >
        {typeof content === "string" ? (
          <Flex width="100%" height="100px" alignItems="center" justifyContent="center" bg={c.surfaceSubtle} borderRadius="8px">
            <Text
              color={c.textSub}
              textAlign="center"
              fontSize="14px"
              fontWeight="300"
            >
              {content}
            </Text>
          </Flex>
        ) : (
          <Box width="100%">
            {content}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StudentClassroomsTile;
